import React, { useCallback, useEffect, useState } from "react";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Loading from "../../../components/Loading";
import styleButton from "../../../components/Button/Button.module.css";
import { useNavigate } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useOutletContext } from "react-router-dom";
import useFormat from "../../../hooks/utils/useFormat";
import ActivityLogs from "../../../components/ActivityLogs";
import PackageItemsCloud from "../../../components/PackageItemsCloud";
import PackageSelectionCard from "../../../components/PackageSelectionCard";

export default function Groups() {
  const navigate = useNavigate();
  const { commercial } = useOutletContext();
  const { formatDate } = useFormat();

  // Convites/Ingressos (Expectativa) configurados pra este evento na planilha de custos, se
  // houver — mostrado pequeno, numa linha própria dentro da tag do evento. Só a quantidade,
  // o valor unitário fica só na planilha de custos.
  const buildInviteNote = __event => {
    if (__event?.qtd_invitations == null && __event?.qtd_tickets == null) return null;

    const _parts = [];
    if (__event?.qtd_invitations != null) _parts.push(`Convites: ${__event.qtd_invitations}`);
    if (__event?.qtd_tickets != null) _parts.push(`Ingressos: ${__event.qtd_tickets}`);
    return _parts.join(" · ");
  };

  useEffect(() => {
    if (commercial) {
      if (!commercial.is_class) {
        navigate(`/business/feed/${commercial.id}`);
      }
    }
  }, [commercial, navigate]);

  const { config, setbreadcrumb, me, token } = useWrapper();
  useEffect(() => {
    if (commercial) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  const [messageItem, setMessageItem] = useState("");
  const [activity, setActivity] = useState([]);
  const handlemessage = event => {
    setMessageItem(event.target.value);
  };

  const loadActivity = useCallback(
    async itemId => {
      setActivity([]);
      const { data: activity_reponse } = await api.get(`activity?commercial_id=${itemId}&paginate=false`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setActivity(activity_reponse);
    },
    [token],
  );

  async function saveMessage() {
    try {
      await api.post(
        "activity",
        {
          message: messageItem,
          user_id: me.id,
          commercial_id: commercial.id,
          type: "msg",
        },
        config,
      );

      setMessageItem("");
      loadActivity(commercial.id);
      toast.success("Comentário salvo com sucesso!");
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }

  useEffect(() => {
    commercial && loadActivity(commercial?.id);
  }, [commercial, loadActivity]);

  return (
    <Main>
      {!!commercial ? (
        <Content noBG="true">
          <Row>
            <Col>
              {!!commercial && (
                <>
                  <SubContent>
                    {(commercial.packages_data.packages.length > 0 || commercial.packages_data.singles.length > 0) && (
                      <>
                        <Row>
                          <Col>
                            <h6 className="mb-2">
                              <b>Pacotes e Avulsos</b>
                            </h6>
                          </Col>
                        </Row>
                        <Row>
                          {commercial.packages_data.packages.length > 0 && (
                            <Col sm={6}>
                              {commercial.packages_data.packages.map((e, i) => (
                                <PackageSelectionCard
                                  key={e.id || i}
                                  disabled
                                  name={
                                    <>
                                      {e.name}
                                      <span className="small-label"> ({e.number_trainees} fomandos)</span>
                                    </>
                                  }
                                  total={formatDate(e.first_event, 7)}
                                >
                                  <PackageItemsCloud
                                    fullWidth
                                    items={e.events.map(e2 => ({
                                      key: e2.id,
                                      label: e2.name,
                                      value: formatDate(e2.date_event, 7),
                                      note: buildInviteNote(e2),
                                    }))}
                                  />
                                </PackageSelectionCard>
                              ))}
                            </Col>
                          )}
                          {commercial.packages_data.singles.length > 0 && (
                            <Col sm={6}>
                              <PackageSelectionCard disabled name="Avulsos">
                                <PackageItemsCloud
                                  fullWidth
                                  items={commercial.packages_data.singles.map((e, i) => ({
                                    key: e.id || i,
                                    label: e.event.name,
                                    value: formatDate(e.date_event, 7),
                                    note: [buildInviteNote(e.event), `Formandos: ${e.number_trainees}`]
                                      .filter(Boolean)
                                      .join(" · "),
                                  }))}
                                />
                              </PackageSelectionCard>
                            </Col>
                          )}
                        </Row>
                      </>
                    )}
                    <div className="divisor mt-4 mb-3"></div>
                    <Row>
                      <Col>
                        <h6 className="m-0">
                          <b>Início das Solenidades</b>
                        </h6>
                        <p>{formatDate(commercial.first_event, 7)}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h6 className="m-0">
                          <b>Data da Última Parcela</b>
                        </h6>
                        <p>{!!commercial.date_end ? formatDate(commercial.date_end, 7) : "-"}</p>
                      </Col>
                    </Row>
                    {/* Campo legado: zerado conta como "não preenchido" (turma que já saiu do
                        esquema antigo), mesmo critério do formulário de edição da turma. */}
                    {commercial.invites_trainees != null && commercial.invites_trainees !== 0 && (
                      <Row>
                        <Col>
                          <h6 className="m-0">
                            <b>Convites por Formando</b>
                          </h6>
                          <p>{commercial.invites_trainees} unidades</p>
                        </Col>
                      </Row>
                    )}
                    {commercial.ticket_trainees != null && commercial.ticket_trainees !== 0 && (
                      <Row>
                        <Col>
                          <h6 className="m-0">
                            <b>Ingressos por Formando</b>
                          </h6>
                          <p>{commercial.ticket_trainees} unidades</p>
                        </Col>
                      </Row>
                    )}
                    <div className="divisor mt-1 mb-4"></div>
                    <div>
                      <button
                        onClick={() => navigate(`/business/edit/${commercial.id}#is_class`)}
                        type="button"
                        className={`${styleButton.button_mini_ghost} mr-3`}
                      >
                        <span>Editar Dados/Pacotes</span>
                      </button>
                    </div>
                  </SubContent>
                  <SubContent className="mt-4">
                    <ActivityLogs
                      activity={activity}
                      messageItem={messageItem}
                      handlemessage={handlemessage}
                      saveMessage={saveMessage}
                    />
                  </SubContent>
                </>
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
